export class Constante {
    static REQUEST_STATUS_OK = 1;
    static REQUEST_STATUS_ERROR = 0;
    static REQUEST_STATUS_VACIO = 2;

    static TOKEN_APP = 'token';
    static INFO_USER = 'infoUser';

    static CART_UUID = 'flower_cart_uuid';
    static CART_EXPIRA = 'flower_cart_expiry';

    static PAGINATION_SIZE = 9;
    static PAGINATION_SIZE_OPTIONS = [6, 9, 12, 18];

    static URL_HOME = '/';
    static URL_CATALOGO = '/catalogo';
    static URL_PRODUCTO = '/producto';
    static URL_CHECKOUT = '/finalizar-compra';
    static URL_SEGUIMIENTO = '/seguimiento';
    static URL_MIS_PEDIDOS = '/mis-pedidos';
    static URL_LOGIN = '/auth/login';
    static URL_REGISTER = '/auth/register';
    static URL_ADMIN = '/admin';
}
